import { MAvatar } from './@material-extend';
// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  return <MAvatar {...other} />;
}
